module.exports = __webpack_public_path__ + "img/chat.eec5b136.svg";